import React,{ Fragment, useState } from 'react';
import ModalNotification from '../../../GlobalComponents/ModalNotification';
import Notification from '../../../Library/notification';
import { withApollo, useQuery, useMutation } from 'react-apollo';
import Loading from '../../../GlobalComponents/Loading';
import Error from '../../../GlobalComponents/Error';
import NoItems from '../../../GlobalComponents/NoItems';
import Helper from '../../../Library/helper';
import translate from '../../Translations/index';
import moment from 'moment';
import AddEditProjectHistory from './AddEditProjectHistory';
import ProjectHistoryLib from '../Library/projectHistory';
import {GET_ALL_PROJECT_HISTORY,DELETE_PROJECT_HISTORY} from '../Queries/projectHistory';
import edit from '../../../Public/Images/edit.svg';

var error = "";
var loading = false;

const ProjectHistory = (props) => {

    const listVariables = {
        projectID:props.projectID
    }

	const [selectedProjectHistory,setSelectedProjectHistory]   = useState([]);
    const [showDeleteNotifi,setShowDeleteNotifi]                     = useState(false);
    const [showAdd,setShowAdd] 			                             = useState(false);
    const [selectedProjectHistoryID,setSelectedProjectHistoryID] = useState(0);
    
    const {loading, error:getError, data:projectHistoryListData, fetchMore}   = useQuery(GET_ALL_PROJECT_HISTORY,{
        variables:listVariables
    });
 
	const [deleteProjectHistory, { data,loading: deleteLoading, error: deleteError }] = useMutation(DELETE_PROJECT_HISTORY,{	
		update(cache,response) {            
            let projectHistory = new ProjectHistoryLib(this);
            projectHistory.updateAfterDelete(cache, response,listVariables);

            let notify = new Notification();
            notify.setNotification(cache,translate.t("SuccessFullyDeleted"),true,false);
            setShowDeleteNotifi(false);
		},						
		onError(err){
            const helper = new Helper(); 
            let notify = new Notification();
            notify.setNotification(null,helper.getApolloErrorText(err),false,true,props.client);
		}
    });

    /**
     * smazání štítků
     * @param {*} deleteProjectHistory funkce, která posílá data na server
     * @param {*} projectHistoryID ID branchu
     */
    
    const initiateDeleteProjectHistory = (e,projectHistoryID) => {

        var checked = e.target.checked;
        var arr = [...selectedProjectHistory];

        if(!checked){
            for(let i in selectedProjectHistory){
                if(selectedProjectHistory[i] == projectHistoryID){
                    arr.splice(i,1);
                }
            }
        }else{
            arr = [projectHistoryID,...arr];
        }

        setSelectedProjectHistory(arr);
  
    }

    const delProjectHistory = (action) => {

        if(action){

            let projectHistoryIDs = selectedProjectHistory.join(",");

            deleteProjectHistory({
                variables:{
                    projectHistoryIDs: projectHistoryIDs
                }
            })
        }
        setShowDeleteNotifi(false);
        //this.setState(INITIAL_STATE);
    }

    const showDelNotifi = () => {

        if(selectedProjectHistory.length > 0){
            setShowDeleteNotifi(true);
        }else{
            let notify = new Notification();
            notify.setNotification(null,translate.t("ItemNotSelected"),false,true,props.client);
        }
    }

    const openCloseModal = (open,projectHistoryID) => {
        setSelectedProjectHistoryID(projectHistoryID);
        setShowAdd(open);
    }

    
    if(getError || deleteError){
        var error = getError ? getError : deleteError;
        const helper = new Helper(); 
        error = "ERROR: " + helper.getApolloErrorText(error)
    }

    return(

        <Fragment>

            {error ?
                <Error text={error} />
                 :
                <Fragment>

                    {loading ? 

                        <Loading />
                
                        :
                        <>
                            <div className="card main">
                            
                                <div className="card-header d-flex align-items-center">
                                    Jak se stavělo
                                    <button className="btn btn-primary btn-thiner ml-auto" onClick={() => openCloseModal(true,0)}>{translate.t("Add")}</button>
                                    <button className="btn btn-danger btn-thiner ml-2" onClick={() => showDelNotifi()}>{translate.t("DeleteSelected")}</button>
                                </div>
                                <div className="card-body">

                                    {!error ?
                                        <div>
                                            <div className="data-list">
                                                
                                                <div className="data-list-item header">
                                                    <div className="data-list-item-content">
                                                        <div>Název</div>
                                                        <div className="text-right static small">{translate.t("Options")}</div>
                                                    </div>
                                                </div>
                                                <Fragment>
                                                    {projectHistoryListData && projectHistoryListData.allProjectHistory && projectHistoryListData.allProjectHistory.map((item,index) => {

                                                        var checked = false;
                                                        for(let i in selectedProjectHistory){
                                                            if(selectedProjectHistory[i] == item.projectHistoryID)checked = true;
                                                        }
                                                                                                                        
                                                        return (
                                                        
                                                            <div key={index} className="data-list-item-content">
                                                                <div>{item.name}</div>                                                        
                                                                <div className="text-right static small">
                                                                    <img onClick={() => openCloseModal(true,item.projectHistoryID)} className="edit-icon" src={edit} />
                                                                    <input className="delete-checked" type="checkbox" name="deleteProjectHistory[]" checked={checked} onChange = {(e) => initiateDeleteProjectHistory(e,item.projectHistoryID)} />
                                                                </div>
                                                            </div>
                                                                    
                                                        )
                                                        
                                                    })} 
                                                </Fragment>
                                            </div>
                                            {!loading ? 
                                                <Fragment>
                                                    {projectHistoryListData && projectHistoryListData.allProjectHistory && projectHistoryListData.allProjectHistory.length == 0 ?
                                                        <NoItems text={translate.t("NoItemsAddedYet")} />
                                                        :  
                                                        <Fragment>     
                                                            {!loading && projectHistoryListData && projectHistoryListData.allProjectHistory.length < projectHistoryListData.branchListCount &&                                 
                                                                <div className="text-center p-5">
                                                                    <button className="btn btn-primary" onClick={() => fetchMore({
                                                                        variables: {...listVariables,
                                                                            offset: projectHistoryListData.allProjectHistory.length
                                                                        },
                                                                        updateQuery: (prev, { fetchMoreResult }) => {
                                                                            if (!fetchMoreResult) return prev;
                                                                            return Object.assign({}, prev, {
                                                                                allProjectHistory: [...prev.allProjectHistory, ...fetchMoreResult.allProjectHistory]
                                                                            });
                                                                        }
                                                                    })}> {translate.t("LoadMore")} </button>
                                                                </div> 
                                                            }
                                                        </Fragment>
                                                    }
                                                </Fragment>
                                                :                                    
                                                <Loading />                                    
                                            }
                                            
                                        </div>
                                        :
                                        <Fragment>
                                            {error &&  <Error text={error} />}
                                        </Fragment>
                                    }
                                </div>
                            </div>

                            {showAdd &&
                                <AddEditProjectHistory openCloseModal={openCloseModal} projectID = {props.projectID} selectedProjectHistoryID={selectedProjectHistoryID} listVariables={listVariables} />
                            }
                            {showDeleteNotifi && <ModalNotification yesNo={true} text={translate.t("RemoveItems?")} callback={delProjectHistory} /> }

                        </>

                    }
                
                    
                </Fragment>
            }
        
        </Fragment>
    )

}

export default withApollo(ProjectHistory);









